const endpoint = process.env.REACT_APP_PHOTON_URL || 'https://photon.komoot.io/api/';

export function locationFromFeature(feature) {
  const properties = feature?.properties;
  const coordinates = feature?.geometry?.coordinates;
  if (!properties || feature?.geometry?.type !== 'Point' || !Array.isArray(coordinates)) return null;
  const [lng, lat] = coordinates;
  if (!Number.isFinite(lat) || !Number.isFinite(lng) || Math.abs(lat) > 90 || Math.abs(lng) > 180 || !properties.country) return null;
  const area = properties.district || properties.locality || properties.name || properties.city || properties.state || properties.country;
  const city = properties.city || properties.county || properties.state || properties.name || properties.country;
  const label = [...new Set([properties.name, properties.district, properties.city, properties.state, properties.country].filter(Boolean))].join(', ');
  return {
    area, city, country: properties.country, lat, lng, label,
    placeId: properties.osm_id && properties.osm_type ? `osm:${properties.osm_type}:${properties.osm_id}` : '',
    locationProvider: 'photon',
  };
}

export async function searchLocations(text, signal) {
  const url = new URL(endpoint);
  url.searchParams.set('q', text.trim());
  url.searchParams.set('limit', '6');
  const response = await fetch(url.toString(), { signal });
  if (!response.ok) throw new Error(response.status === 429 ? 'Location search is busy. Please wait a moment and try again.' : 'Location search is unavailable. Please try again.');
  const data = await response.json();
  if (!Array.isArray(data.features)) throw new Error('Location search returned an invalid response. Please try again.');
  const seen = new Set();
  return data.features.map(locationFromFeature).filter((location) => {
    if (!location) return false;
    const key = `${location.label}:${location.lat}:${location.lng}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
